var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { LayoutComponentDisplay } from "../layoutComponentDisplay";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
import copy from "fast-copy";
import { useTranslation } from "react-i18next";
import { FormSettingsContext, findTabComponentIndex, getColorStyle, getLayoutStyle, getStyleSpacing, scrollToEl, } from "../../utils";
import { FormComponentButtons } from "../../formComponentButtons";
import "./settings";
import "./list";
import { LayoutButtons } from "../../layoutButtons";
import { useAppSelector } from "@/hooks/store";
import { spacingOngletsClass, borderColorTabSelectedClass, borderRadiusTabSelectedClass, borderRadiusTabClass, borderRadiusTabHoverClass, } from "@/utils/funcs";
/**
 * <b>Composant de rendu d'un groupe d'onglets qui va afficher les enfants de type tab</b>
 *
 */
export function Tab(_a) {
    var _b, _c;
    var module = _a.module, viewType = _a.viewType, fieldDefs = _a.fieldDefs, record = _a.record, fetchedRecord = _a.fetchedRecord, layouts = _a.layouts, onHandleUpdate = _a.onHandleUpdate, validations = _a.validations, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen;
    var tabComponent = useMemo(function () { return layouts[0] || {}; }, [layouts]);
    var tabElements = useMemo(function () { return tabComponent.components || []; }, [tabComponent]);
    var t = useTranslation(["common", module]).t;
    /**
     * Liste des entêtes d'onglets
     */
    var _d = useState([]), tabHeaders = _d[0], setTabHeaders = _d[1];
    /**
     * Index sélectionné du composant d'onglet
     */
    var _e = useState(0), selectedIndex = _e[0], setSelectedIndex = _e[1];
    /**
     * Mise en place des headers lorsque le tableay change
     */
    useEffect(function () {
        if (tabComponent.settings && tabComponent.settings.labels) {
            var tabHeaders_1 = tabComponent.settings.labels.map(function (header) {
                return header;
            });
            setTabHeaders(tabHeaders_1);
        }
    }, [tabComponent.settings && tabComponent.settings.labels, tabElements]);
    var _f = useState(copy(record)), editedRecord = _f[0], setEditedRecord = _f[1];
    var updateRecord = function (edited) {
        setEditedRecord(edited);
        onHandleUpdate && onHandleUpdate(edited);
    };
    // Css pour le studio
    var borderStyle = isStudioField
        ? "border border-gray-500 border-dashed"
        : "";
    var _g = useContext(FormSettingsContext), settings = _g.settings, editedSettings = _g.editedSettings;
    var refs = useRef(null);
    var onClickComponent = function (e) {
        e.stopPropagation();
        editedSettings(__assign(__assign({}, settings), { target: tabComponent.id, type: tabComponent.type, component: tabElements, selected: tabComponent.id, parentId: "", currentComponent: tabComponent }));
        scrollToEl(refs && (refs === null || refs === void 0 ? void 0 : refs.current));
    };
    // si composant séléctionné
    useEffect(function () {
        // Mise à jour tab suivant composant sélectionné
        if (isStudioField && tabComponent.components && settings.selected !== "") {
            var index = findTabComponentIndex(tabComponent, settings.selected);
            setSelectedIndex(index === -1 ? 0 : index);
        }
        // Mise à jour settings
        isStudioField &&
            settings.selected === tabComponent.id &&
            editedSettings(__assign(__assign({}, settings), { target: tabComponent.id, type: tabComponent.type, component: tabElements, selected: tabComponent.id, parentId: layoutParent, currentComponent: tabComponent }));
    }, [isStudioField && settings.selected]);
    // Styles
    var _h = useState(), styles = _h[0], setStyles = _h[1];
    var _j = useState(""), labelColor = _j[0], setLabelColor = _j[1];
    useEffect(function () {
        var _a, _b;
        var colorStyle = getColorStyle(((_a = tabComponent.settings) === null || _a === void 0 ? void 0 : _a.styles) || {});
        setLabelColor(colorStyle.color);
        delete colorStyle.color;
        var spacingStyle = (tabComponent.settings && __assign(__assign({}, getStyleSpacing(((_b = tabComponent.settings) === null || _b === void 0 ? void 0 : _b.styles) || {})), colorStyle)) ||
            "";
        setStyles(__assign({}, spacingStyle));
    }, [(_b = tabComponent === null || tabComponent === void 0 ? void 0 : tabComponent.settings) === null || _b === void 0 ? void 0 : _b.styles]);
    var fontOpacity = useAppSelector(function (state) { return state.theme; }).fontOpacity;
    var tabPosition = ((_c = fontOpacity === null || fontOpacity === void 0 ? void 0 : fontOpacity.tabs) === null || _c === void 0 ? void 0 : _c.tab_position) || "left";
    var isJustifyBetween = tabPosition === "justify";
    var justifyClass = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
        justify: "justify-between",
    }[tabPosition];
    return (_jsx("div", __assign({ className: "flex flex-col w-auto ".concat(borderStyle, " ml-[var(--margin-ml-detail-view-fiche)] mb-[var(--margin-mb-detail-view-fiche)]  mr-[var(--margin-mr-detail-view-fiche)]"), onClick: function (v) {
            isStudioField && onClickComponent(v);
        }, style: getLayoutStyle(isSelected === tabComponent.id) }, { children: _jsxs("div", __assign({ style: styles, ref: function (el) {
                if (el)
                    refs.current = el;
            }, id: tabComponent.id }, { children: [_jsxs("div", __assign({ className: "w-full pl-2 pt-2 border-dashed relative\n          mt-[var(--margin-mt-tabs)] mr-[var(--margin-mr-tabs)]\n          mb-[var(--margin-mb-tabs)] ml-[var(--margin-ml-tabs)] bg-[var(--colors-tabs)]\n        " }, { children: [_jsx("ul", __assign({ className: "flex ".concat(justifyClass, " w-full flex-wrap text-sm font-medium text-center text-[var(--colors-tab)]") }, { children: tabHeaders.map(function (item, i) { return (_jsx("li", __assign({ className: "cursor-pointer ".concat(isJustifyBetween ? "flex-1" : ""), onClick: function (e) {
                                    e.stopPropagation();
                                    setSelectedIndex(i);
                                } }, { children: _jsx("span", __assign({ className: "relative block  text-[".concat(labelColor, "] p-4 ").concat(spacingOngletsClass, "  ").concat(
                                    //padding pour le tabs
                                    i === selectedIndex
                                        ? "text-[var(--colors-tab)] bg-[var(--colors-tab-selected)]\n                      ".concat(borderRadiusTabSelectedClass, "\n                       ").concat(borderColorTabSelectedClass, "\n                       ") //-border-b-4 border-b-blue-500
                                        : "".concat(borderRadiusTabClass, " ").concat(borderRadiusTabHoverClass, " hover:text-[var(--colors-tab-text-survol)] text-[var(--colors-tab-text)] bg-[var(--colors-tab)] hover:bg-[var(--colors-tab-hovered)]")), style: __assign({ color: labelColor }, (i === selectedIndex && {
                                        borderTopWidth: "var(--border-width-tab-selected-top)",
                                        borderBottomWidth: "var(--border-width-tab-selected-bottom)",
                                        borderLeftWidth: "var(--border-width-tab-selected-left)",
                                        borderRightWidth: "var(--border-width-tab-selected-right)",
                                    })) }, { children: (function () {
                                        var key = typeof item === "string" ? item.toUpperCase() : item;
                                        var translationModule = t(key, { ns: module });
                                        return translationModule === key
                                            ? t("app.".concat(item), { ns: "common" })
                                            : translationModule;
                                    })() })) }), "".concat(item.label, "_").concat(i))); }) })), isStudioField && (_jsxs(_Fragment, { children: [_jsx(FormComponentButtons, { parentId: "", meta: (settings && settings) || [], isLayout: true, isSelected: isSelected === tabComponent.id }), _jsx(LayoutButtons, { parentId: "", component: tabComponent || [], isLayout: true })] }))] })), _jsxs("div", __assign({ className: "" }, { children: [" ", _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: fieldDefs, record: editedRecord, fetchedRecord: fetchedRecord, layouts: tabComponent.components[selectedIndex], onHandleUpdate: updateRecord, validations: validations, isStudioField: isStudioField, isSelected: isSelected, layoutParent: tabComponent, viewScreen: viewScreen })] }))] })) })));
}
layoutComponentsDictionary.registerLayoutComponent("tab", Tab);
